import z from 'zod';
import { ThemeModeSchema, UserTypeSchema } from '../common/schemas';
import { MfaMethod } from './enums';

/**
 * Shared & Helper Schemas
 */

export const MfaMethodSchema = z.enum(MfaMethod);

export const UserIdSchema = z
  .string()
  // Based on AWS Cognito's username format, which notably looks like a UUID,
  // but doesn't follow UUID convention
  .regex(/^[\p{L}\p{M}\p{S}\p{N}\p{P}]{1,128}$/u)
  .openapi({
    description: 'Unique username for the user',
    example: 'f47ac10b-58cc-4372-a567-0e02b2c3d479',
  });

export const DBUserSharedSettingsSchema = z.object({
  themeMode: ThemeModeSchema,
});

export const DBUserTypeSchema = UserTypeSchema;
